import { render } from "./AppFooter.vue?vue&type=template&id=3ef08e78&scoped=true"
import script from "./AppFooter.vue?vue&type=script&lang=js"
export * from "./AppFooter.vue?vue&type=script&lang=js"

import "./AppFooter.vue?vue&type=style&index=0&id=3ef08e78&lang=scss&scoped=true"

import exportComponent from "/home/duanpengyuan/Projects/dcp-demo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ef08e78"]])

export default __exports__